import React, { Component } from "react"
import styled from "styled-components"

import scale from "../helper/scaling"
import ArticleAbstract, { FlatBody } from "./ArticleAbstract"

const Wrapper = styled.div`
  width: 1050px;
  margin: 45px calc(50% - 525px) 25px calc(50% - 525px);
  float: left;
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    margin: 40px 25px 25px 25px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 35px 23px 23px 23px;
  }
`
const Header = styled.div`
  width: 100%;
  float: left;

  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 58px;
  letter-spacing: 0.4px;
  color: #3949ab;

  margin-bottom: 15px;

  float: left;

  @media (max-width: 1100px) {
    margin-bottom: 7px;
    font-size: 25px;
  }
  @media (max-width: 700px) {
    margin-bottom: 0px;
    font-size: 22px;
  }
`
const Items = styled.div`
  width: 100%;
  float: left;
`

class SetExpansionPanels extends Component {
  render() {
    let first = this.props.set[0]
    let items = []
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i])
    }
    return (
      <Wrapper>
        <Header>{first.title}</Header>
        <Items>{items.map(item => <ExpansionPanel key={item.id} content={item} />)}</Items>
      </Wrapper>
    )
  }
}

export default SetExpansionPanels

const Item = styled.div`
  width: 100%;
  float: left;
`
const Upper = styled.div`
  width: 100%;
  border-bottom: solid 1px #e5e5e5;
  float: left;

  cursor: pointer;

  position: relative;
`
const Title = styled.div`
  margin: 20px 20px 21px 58px;
  width: calc(100% - 78px);
  float: left;

  line-height: 29px;
  font-family: Lato;
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  color: ${props => (props.open ? "#3949ab;" : "rgba(0, 0, 0, 0.85)")};

  @media (max-width: 1100px) {
    margin: 14px 14px 14px 40px;
    width: calc(100% - 54px);

    line-height: ${scale(1100, 700, 29, 19, "vw")};
    font-size: ${scale(1100, 700, 24, 16, "vw")};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.2px;
  }

  @media (max-width: 700px) {
    line-height: 19px;
    font-size: 16px;
    letter-spacing: 0.2px;
  }
`
const Icon = styled.div`
  width: 18px;
  height: 18px;
  position: absolute;
  top: 27px;
  left: 20px;

  svg {
    height: 100%;
    width: 100%;
    float: left;
  }
  @media (max-width: 1100px) {
    width: 12px;
    height: 12px;
    top: calc(50% - 6px);
    left: 14px;
  }
`
const Lower = styled.div`
  width: 100%;
  float: left;
  max-height: ${props => (props.open ? "auto" : "0")};
  overflow: hidden;
`
const Body = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.85);

  margin: 20px;
  width: calc(100% - 40px);

  float: left;

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 700, 18, 12, "vw")};
    line-height: ${scale(1100, 700, 18 * 1.67, 12 * 1.75, "vw")};
    letter-spacing: ${scale(1100, 700, 1.3, 0.8, "vw")};

    margin: 14px;
    width: calc(100% - 28px);
  }
  @media (max-width: 700px) {
    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.8px;
  }
`

class ExpansionPanel extends ArticleAbstract {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  toggle = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    return (
      <Item>
        <Upper onClick={this.toggle}>
          <Title open={this.state.open}>{this.title()}</Title>
          <Icon>{this.state.open ? <Cross /> : <Plus />}</Icon>
        </Upper>
        <Lower open={this.state.open}>
          <Body>
            <FlatBody>{this.body()}</FlatBody>
          </Body>
        </Lower>
      </Item>
    )
  }
}

class Cross extends Component {
  render() {
    return (
      <svg
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 40 0 L 60 0 L 60 40 L 100 40 L 100 60 L 60 60 L 60 100 L 40 100 L 40 60 L 0 60 L 0 40 L 40 40"
          fill="#ff5368"
          transform="rotate(-45 50 50)"
        />
      </svg>
    )
  }
}

class Plus extends Component {
  render() {
    return (
      <svg
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 40 0 L 60 0 L 60 40 L 100 40 L 100 60 L 60 60 L 60 100 L 40 100 L 40 60 L 0 60 L 0 40 L 40 40"
          fill="#3949ab"
        />
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SetExpansionPanels.js